import styled from "styled-components";
import { Typography, TypographyVariant } from "../ui-kit";

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 70vh;
`;

const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Code = styled(Typography)`
  font-size: 45px;
  margin-top: 15px;
`;

const Unavailable = styled(Typography)`
  margin-top: 20px;
`;

const PageNotFound: React.FunctionComponent = () => {
  return (
    <Container>
      <Wrapper>
        <Code variant={TypographyVariant.HEADER1}>404</Code>
        <Unavailable variant={TypographyVariant.HEADER1}>
          Page not found
        </Unavailable>
      </Wrapper>
    </Container>
  );
};

export default PageNotFound;
